"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _constants = require("./util/constants");

var DataSync = _interopRequireWildcard(require("./util/DataSync"));

var _cache = _interopRequireDefault(require("./util/cache"));

var _Participant = _interopRequireDefault(require("./Participant"));

var _Message = _interopRequireDefault(require("./Message"));

var _Local = _interopRequireDefault(require("./stream/Local"));

var _Invite = _interopRequireDefault(require("./Invite"));

var Events = _interopRequireWildcard(require("../definitions/Events"));

var Log = _interopRequireWildcard(require("./util/Log"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var _joinRoom = function _joinRoom(room, role) {
  var uid = _cache.default.user.uid.split('/').join(':');

  if (room.status !== _constants.CLOSED) {
    var participant = {
      status: _constants.CONNECTED,
      userAgent: _cache.default.userAgent,
      _joined: DataSync.ts()
    };

    if (role) {
      participant.role = role;
    }

    Log.w('Room#join', [participant, "_/rooms/".concat(room.uid, "/participants/").concat(uid)]);
    return DataSync // .update(`_/rooms/${room.uid}/participants/${cache.user.uid}`, participant)
    .update("_/rooms/".concat(room.uid, "/participants/").concat(uid), participant).then(function () {
      return room;
    });
    /* .then(() => {
      DataSync
        .onDisconnect(`_/rooms/${room.uid}/participants/${shortUserId}/status`)
        .set(WAS_CONNECTED);
      return room;
    }); */
  }

  return Promise.reject(new Error('can\'t join a close room'));
};
/**
 * Room information
 * @access public
 */


var Room =
/*#__PURE__*/
function () {
  /**
   * Create a room
   * @param {Webcom/api.DataSnapshot|Object} snapData The data snapshot
   * @access protected
   */
  function Room(snapData, roomUid) {
    _classCallCheck(this, Room);

    var values = snapData;

    if (snapData && snapData.val && typeof snapData.val === 'function') {
      // values = Object.assign({}, snapData.val(), {uid: snapData.name()});
      values = Object.assign({}, snapData.val(), {
        uid: roomUid
      });
    }
    /**
     * The room unique id
     * @type {string}
     */


    this.uid = values.uid;
    /**
     * The room name
     * @type {string}
     */

    this.name = values.name;
    /**
     * The local stream of the room
     * @type {Local}
     */

    this.localStream = {};
    /**
     * The room owner uid
     * @type {string}
     */

    this.owner = values.owner;
    /**
     * The room status:
     * - OPENED
     * - CLOSED
     * @type {string}
     */

    this.status = values.status;
    /**
     * Indicates that the room is public so all users can join
     * @type {boolean}
     */

    this._public = !!values._public;
    /**
     * Additional room informations
     * @type {Object}
     */

    this.extra = values.extra;
    /**
     * List of declared callbacks
     * @type {Object}
     */

    this._callbacks = {};
  }
  /**
   * Get the list of participants.
   * This will only work if the user is either a participant or the owner of the room.
   * @returns {Promise<Participant[], Error>}
   */


  _createClass(Room, [{
    key: "participants",
    value: function participants() {
      return DataSync.list("_/rooms/".concat(this.uid, "/participants"), _Participant.default, this.uid);
    }
    /**
     * Get the list of messages.
     * This will only work if the user is either a participant or the owner of the room.
     * @return {Promise<Message[], Error>}
     */

  }, {
    key: "messages",
    value: function messages() {
      return DataSync.list("_/rooms/".concat(this.uid, "/messages"), _Message.default, this.uid);
    }
    /**
     * Get the list of streams
     * @returns {Promise}
     * @access private
     */

  }, {
    key: "_streams",
    value: function _streams(localStreams) {
      var _this = this;

      if (!_cache.default.user) {
        return Promise.reject(new Error('Only an authenticated user can list a Room\'s streams.'));
      }

      return DataSync.get("_/rooms/".concat(this.uid, "/streams")).then(function (snapData) {
        var values = snapData.val();
        Log.d('Rooms~_streams', values);

        if (values) {
          return Object.keys(values).map(function (key) {
            return Object.assign({
              uid: key,
              roomId: _this.uid
            }, values[key]);
          });
        }

        return [];
      }).then(function (streams) {
        return streams.filter(function (stream) {
          return localStreams === (stream.device === _cache.default.device && stream.from === _cache.default.user.uid);
        });
      }).then(function (streams) {
        return streams.map(_cache.default.streams["get".concat(localStreams ? 'Shared' : 'Remote')].bind(_cache.default.streams));
      }).then(function (streams) {
        return streams.filter(function (stream) {
          return stream !== null;
        });
      });
    }
    /**
     * Get the list of locally published streams.
     * The streams published with another device won't be visible here
     * This will only work if the user is either a participant or the owner of the room.
     * @return {Promise<Local[], Error>}
     */

  }, {
    key: "localStreams",
    value: function localStreams() {
      return this._streams(true).catch(Log.r('Room~localStreams'));
    }
    /**
     * Get the list of remotely published streams.
     * This will only work if the user is either a participant or the owner of the room.
     * @return {Promise<Remote[], Error>}
     */

  }, {
    key: "remoteStreams",
    value: function remoteStreams() {
      return this._streams(false).catch(Log.r('Room~remoteStreams'));
    }
    /**
     * Invite users to the room.
     * This will only work if the current User is the owner or a moderator of this Room.
     * This will create the invitation and add the user to the participants list.
     * @param {User[]} users the users to invite
     * @param {string} [role='NONE'] the role of the invitee
     * @param {string} [message] a message to add to the invite
     * @return {Promise<{room: Room, invites: Invite[]}, Error>}
     */

  }, {
    key: "invite",
    value: function invite(users) {
      var _this2 = this;

      var role = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _constants.NONE;
      var message = arguments.length > 2 ? arguments[2] : undefined;

      var _path = function _path(user) {
        return "_/rooms/".concat(_this2.uid, "/participants/").concat(user.uid);
      };

      var _data = {
        status: _constants.NOT_CONNECTED,
        role: role || _constants.NONE
      }; // Add users as participant so they can join the room

      return Promise.all(users.map(function (user) {
        return DataSync.set(_path(user), _data);
      })) // Send invites
      .then(function () {
        return Promise.all(users.map(function (user) {
          return _Invite.default.send(user, _this2, message);
        }));
      }).then(function (invites) {
        var removeParticipant = function removeParticipant(invite) {
          return DataSync.remove("_/rooms/".concat(invite.room, "/participants/").concat(invite.to));
        };

        invites.forEach(function (invite) {
          invite.on(_constants.REJECTED, removeParticipant);
          invite.on(_constants.CANCELED, removeParticipant);
        });
        return {
          room: _this2,
          invites: invites
        };
      }).catch(function (e) {
        Log.e('Room~invite', e);
        users.forEach(function (user) {
          return DataSync.remove("_/rooms/".concat(_this2.uid, "/participants/").concat(user.uid));
        });
        return Promise.reject(e);
      });
    }
    /**
     * Register a callback for a specific event
     * @param {string} event The event name ({@link Events/Room}):
     * - PARTICIPANT_ADDED: a participant is added to the room
     * - PARTICIPANT_CHANGED: a participant changes his status (join)
     * - PARTICIPANT_REMOVED: a participant leave the room
     * - MESSAGE_ADDED: new instant message
     * - MESSAGE_CHANGED: an existing message has been modified (moderation)
     * - MESSAGE_REMOVED: a message has been removed (moderation)
     * - STREAM_PUBLISHED: a participant published a new Stream
     * - STREAM_CHANGED: a participant changes his published Stream (moderation, type, mute...)
     * - STREAM_UNPUBLISHED: a participant stops the publication of his Stream
     * @param {function} callback
     * The callback for the event, the arguments depends on the type of event:
     * - PARTICIPANT_* : callback({@link Participant} p [, Error e])
     * - MESSAGE_* : callback({@link Message} m [, Error e])
     * - STREAM_* : callback({@link Remote} s [, Error e])
     * @param {Webcom/api.Query~cancelCallback} cancelCallback The error callback for the event,
     * takes an Error as only argument
     */

  }, {
    key: "on",
    value: function on(event, callback, cancelCallback) {
      var _this3 = this;

      var path = Events.room.toPath(event)(this);
      var Obj = Events.room.toClass(event);

      if (path && Obj) {
        var typedCallback = function typedCallback(snapData) {
          if (!/^STREAM_/i.test(event) || !snapData) {
            // if(/^MESSAGE_/i.test(event) || !snapData) {
            Log.i("Room~on(".concat(event, ")"), snapData ? new Obj(snapData) : null);
            callback(snapData ? new Obj(snapData) : null);
          } else if (_cache.default.user) {
            var streamData = Object.assign({
              uid: snapData.name(),
              roomId: _this3.uid
            }, snapData.val());

            if (streamData.from !== _cache.default.user.uid || streamData.device !== _cache.default.device) {
              var remoteStream = _cache.default.streams.getRemote(streamData);

              Log.i("Room~on(".concat(event, ")"), remoteStream);
              callback(remoteStream);
            }
          }
        };

        DataSync.on(path, event, typedCallback, cancelCallback);

        if (!this._callbacks[event]) {
          this._callbacks[event] = [];
        }

        this._callbacks[event].push(typedCallback);
      }
    }
    /**
     * Send an instant message
     * @param {string} message The message to send
     * @return {Promise<Message>}
     */

  }, {
    key: "sendMessage",
    value: function sendMessage(message) {
      return _Message.default.send(this, message);
    }
    /**
     * Publish a local stream
     * @param {string} type The stream type, see {@link StreamTypes} for possible values
     * @param {Element} [localStreamContainer] The element the stream is attached to.
     * Can be null if already specified in {@link Config}.
     * @param {MediaStreamConstraints} [constraints] The stream constraints.
     * If not defined, the constraints defined in {@link Config} will be used.
     * @returns {Promise<Local, Error>}
     */

  }, {
    key: "share",
    value: function share(type, localStreamContainer, constraints) {
      Log.i('Room~share', {
        type: type,
        localStreamContainer: localStreamContainer,
        constraints: constraints
      }); // return Local.share(this.uid, type, localStreamContainer, constraints);

      return _Local.default.getLocalVideo(this.uid, type, localStreamContainer, constraints).then(function (stream) {
        return stream.publish(stream);
      });
    }
    /**
     * get a local stream in video tag
     * @param {string} type The stream type, see {@link StreamTypes} for possible values
     * @param {Element} [localStreamContainer] The element the stream is attached to.
     * Can be null if already specified in {@link Config}.
     * @param {MediaStreamConstraints} [constraints] The stream constraints.
     * If not defined, the constraints defined in {@link Config} will be used.
     * @returns {Promise<Local, Error>}
     */

  }, {
    key: "getLocalVideo",
    value: function getLocalVideo(type, localStreamContainer, constraints) {
      var _this4 = this;

      Log.i('Room~getLocalVideo', {
        type: type,
        localStreamContainer: localStreamContainer,
        constraints: constraints
      });
      return _Local.default.getLocalVideo(this.uid, type, localStreamContainer, constraints).then(function (localStream) {
        _this4.localStream = localStream;
        return localStream;
      });
    }
    /**
     * publish a local stream
     * @returns {Local}
     */

  }, {
    key: "publish",
    value: function publish() {
      Log.i('Room~publish Local');
      return this.localStream.publish(this.localStream);
    }
    /**
     * Join the room. Sets the connected status of the current participant to CONNECTED.
     * @return {Promise}
     */

  }, {
    key: "join",
    value: function join() {
      Log.i('Room~join', this);

      if (!_cache.default.user) {
        return Promise.reject(new Error('Only an authenticated user can join a Room.'));
      }

      return _joinRoom(this).catch(Log.r('Room~join'));
    }
    /**
     * Leave the room. Sets the connected status of the current participant to WAS_CONNECTED,
     * deletes medias and callbacks, closes WebRTC stacks in use.
     * @return {Promise}
     */

  }, {
    key: "leave",
    value: function leave() {
      var _this5 = this;

      if (!_cache.default.user) {
        return Promise.reject(new Error('Only an authenticated user can leave a Room.'));
      }

      Log.i('Room~leave', this); // Cancel onDisconnect

      var uid = _cache.default.user.uid.split('/').join(':');

      DataSync.onDisconnect("_/rooms/".concat(this.uid, "/participants/").concat(uid, "/status")).cancel(); // Disconnect user's callbacks

      Object.keys(this._callbacks).forEach(function (event) {
        DataSync.off(Events.room.toPath(event)(_this5), event);
      }); // Unpublish all published local streams

      this.localStreams().then(function (localStreams) {
        return localStreams.forEach(function (localStream) {
          return localStream.close();
        });
      }); // Unsubscribe all remote streams

      this.remoteStreams().then(function (remoteStreams) {
        return remoteStreams.forEach(function (remoteStream) {
          return remoteStream.unSubscribe();
        });
      }); // Update status

      return DataSync.set("_/rooms/".concat(this.uid, "/participants/").concat(uid, "/status"), _constants.WAS_CONNECTED) // return DataSync.set(`_/rooms/${this.uid}/participants/${shortUserId}/status`, WAS_CONNECTED)
      .catch(Log.r('Room~leave'));
    }
    /**
     * Leaves & close the Room. Only the owner/moderator can close a room.
     * @return {Promise}
     */

  }, {
    key: "close",
    value: function close() {
      var _this6 = this;

      Log.i('Room~close', this);
      this.status = _constants.CLOSED;
      return this.leave().then(function () {
        return DataSync.update("rooms/".concat(_this6.uid), {
          status: _constants.CLOSED,
          _closed: DataSync.ts()
        });
      }).then(function () {
        return DataSync.remove("_/rooms/".concat(_this6.uid));
      }).catch(Log.r('Room~close'));
    }
    /**
     * Create a room
     * @access protected
     * @param {String} [name] The room name
     * @param {object} [extra=null] Extra informations
     * @param {boolean} [publicRoom=false] Indicates public room
     * @returns {Promise<Room, Error>}
     */

  }], [{
    key: "create",
    value: function create(name) {
      var extra = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var publicRoom = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      if (!_cache.default.user) {
        return Promise.reject(new Error('Only an authenticated user can create a Room.'));
      }

      var roomMetaData = {
        owner: _cache.default.user.uid,
        _public: publicRoom,
        name: name || "".concat(_cache.default.user.name, "-").concat(Date.now())
      };
      var roomFullMetaData = Object.assign({
        status: _constants.OPENED,
        _created: DataSync.ts(),
        extra: extra
      }, roomMetaData);
      var room = null; // Create public room infos
      // return DataSync.push('rooms', roomFullMetaData)

      var id1 = Math.floor(Math.random() * 1000);
      var id2 = Math.floor(Math.random() * 1000);
      return DataSync.push("rooms/".concat(id1, "/").concat(id2), roomFullMetaData) // Create private room infos
      .then(function (roomRef) {
        room = new Room(Object.assign({
          uid: "".concat(id1, "/").concat(id2, "/").concat(roomRef.name())
        }, roomFullMetaData));
        _cache.default.room = roomFullMetaData;
        return DataSync.update("_/rooms/".concat(room.uid, "/meta"), roomMetaData);
      }) // Join the room
      .then(function () {
        return _joinRoom(room, _constants.OWNER);
      }).catch(Log.r('Room#create'));
    }
    /**
     * Get a {@link Room} from its `uid`
     * @access protected
     * @param uid
     * @returns {Promise.<Room>}
     */

  }, {
    key: "get",
    value: function get(uid) {
      return DataSync.get("rooms/".concat(uid)).then(function (snapData) {
        if (snapData.val()) {
          return new Room(snapData, uid);
        }

        return null;
      });
    }
  }]);

  return Room;
}();

exports.default = Room;